/* eslint-disable */
import { scrollToPos } from "./helpers";


document.addEventListener("alpine:init", () => {

    Alpine.data("buttonAnchor", () => ({
        scrollToPos(id) {
            scrollToPos(id);
        },
        buttonEvent(id) {
            const tabComponent = document.querySelector(".tabComponent");
            
            this.scrollToPos(id);
            if (tabComponent) this.$dispatch('open-tab', { tabId: id });
        }
    }));

});
